(() => {
  const ABOUT_TEMPLATE_CLASS = 'template-about-us';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  const revealGroups = [
    {
      selector: '.template-about-us .custom_images .absoluted_txt h2',
      variant: 'about-reveal--zoom',
      baseDelay: 40,
      stepDelay: 80,
    },
    {
      selector: '.template-about-us .custom_image_text .cstm_font, .template-about-us .custom_image_text .image-with-text__text p',
      variant: 'about-reveal--left',
      baseDelay: 70,
      stepDelay: 60,
    },
    {
      selector: '.template-about-us .custom_image_text .image-with-text__media-item',
      variant: 'about-reveal--right',
      baseDelay: 120,
      stepDelay: 80,
    },
    {
      selector: '.template-about-us .image_txt_padding .image-with-text__media-item',
      variant: 'about-reveal--left',
      baseDelay: 90,
      stepDelay: 80,
    },
    {
      selector: '.template-about-us .image_txt_padding .cstm_font, .template-about-us .image_txt_padding .image-with-text__text p, .template-about-us .image_txt_padding .image-with-text__content > img',
      variant: 'about-reveal--right',
      baseDelay: 120,
      stepDelay: 55,
    },
    {
      selector: '.template-about-us .featureicon_rotating',
      variant: 'about-reveal',
      baseDelay: 30,
      stepDelay: 0,
    },
    {
      selector: '.template-about-us .collapsible-content .gradient_button, .template-about-us .collapsible-content .collapsible-content__heading.inline-richtext',
      variant: 'about-reveal--zoom',
      baseDelay: 25,
      stepDelay: 65,
    },
    {
      selector: '.template-about-us .collapsible-content .accordion',
      variant: 'about-reveal--left',
      baseDelay: 80,
      stepDelay: 70,
    },
    {
      selector: '.template-about-us .multicolumn .title, .template-about-us .multicolumn .multicolumn-list__item',
      variant: 'about-reveal--right',
      baseDelay: 35,
      stepDelay: 70,
    },
  ];

  function isAboutTemplate() {
    return document.body && document.body.classList.contains(ABOUT_TEMPLATE_CLASS);
  }

  function prepareReveals() {
    const elements = [];

    revealGroups.forEach((group) => {
      const nodeList = document.querySelectorAll(group.selector);
      nodeList.forEach((node, index) => {
        if (node.dataset.aboutRevealApplied === 'true') {
          elements.push(node);
          return;
        }

        node.dataset.aboutRevealApplied = 'true';
        node.classList.add('about-reveal');

        if (group.variant && group.variant !== 'about-reveal') {
          node.classList.add(group.variant);
        }

        const delay = group.baseDelay + index * group.stepDelay;
        node.style.setProperty('--about-delay', `${delay}ms`);
        elements.push(node);
      });
    });

    return elements;
  }

  function revealOnIntersect(elements) {
    if (!elements.length) return;

    if (window.matchMedia(REDUCED_MOTION_QUERY).matches) {
      elements.forEach((element) => element.classList.add('about-reveal--in'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('about-reveal--in');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.16,
        rootMargin: '0px 0px -12% 0px',
      }
    );

    elements.forEach((element) => observer.observe(element));
  }

  function initializeHeroParallax() {
    if (window.matchMedia(REDUCED_MOTION_QUERY).matches) return;
    if (window.matchMedia('(max-width: 1023px)').matches) return;

    const hero = document.querySelector('.template-about-us .custom_images');
    const heroImages = hero ? hero.querySelectorAll('.flex_image img') : [];
    if (!hero || !heroImages.length) return;
    if (hero.dataset.aboutParallaxBound === 'true') return;
    hero.dataset.aboutParallaxBound = 'true';

    let rafId = null;

    const updateHeroParallax = () => {
      rafId = null;
      const heroRect = hero.getBoundingClientRect();
      const viewportCenter = window.innerHeight * 0.5;
      const heroCenter = heroRect.top + heroRect.height * 0.5;
      const progress = Math.max(-1, Math.min(1, (viewportCenter - heroCenter) / window.innerHeight));

      heroImages.forEach((image, index) => {
        const distance = index === 0 ? 18 : -18;
        image.style.transform = `translate3d(0, ${Math.round(progress * distance)}px, 0) scale(1.03)`;
      });
    };

    const requestUpdate = () => {
      if (rafId !== null) return;
      rafId = window.requestAnimationFrame(updateHeroParallax);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  }

  function initializeFloatingAccents() {
    const founderImage = document.querySelector('.template-about-us .image_txt_padding .image-with-text__media img');
    if (founderImage) {
      founderImage.classList.add('about-float');
    }

    const valueIcons = document.querySelectorAll(
      '.template-about-us .multicolumn .multicolumn-card__image-wrapper--third-width'
    );

    valueIcons.forEach((icon, index) => {
      icon.classList.add('about-float');
      icon.style.setProperty('--about-float-delay', `${index * 140}ms`);
    });
  }

  function initializeAccordionState() {
    const accordions = document.querySelectorAll('.template-about-us .collapsible-content .accordion');

    accordions.forEach((accordion) => {
      if (accordion.dataset.aboutToggleBound === 'true') return;
      const details = accordion.querySelector('details');
      if (!details) return;

      const syncState = () => {
        accordion.classList.toggle('about-open', details.hasAttribute('open'));
      };

      accordion.dataset.aboutToggleBound = 'true';
      syncState();
      details.addEventListener('toggle', syncState);
    });
  }

  function initializeAboutAnimations() {
    if (!isAboutTemplate()) return;

    const revealElements = prepareReveals();
    revealOnIntersect(revealElements);
    initializeHeroParallax();
    initializeFloatingAccents();
    initializeAccordionState();
  }

  document.addEventListener('DOMContentLoaded', initializeAboutAnimations);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initializeAboutAnimations);
    document.addEventListener('shopify:section:reorder', initializeAboutAnimations);
  }
})();
